// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2Y2VG","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__3IZw8","gfeWrapper":"CalendarEvent_gfeWrapper__2Coh1"};